module.exports = __webpack_public_path__ + "static/media/botones-16.94da215a.png";